import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-675404e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "recent-activities-widget"
}
const _hoisted_2 = { class: "recent-activities-widget__time" }
const _hoisted_3 = { class: "recent-activities-widget__message" }
const _hoisted_4 = {
  key: 1,
  class: "recent-activities-widget__footer"
}

import { computed, ref, watch } from 'vue';
import DashboardWidget from '@/components/dashboard/DashboardWidget.vue';
import { useDashboardQuery } from '@/core/hooks/useDashboardQuery';
import { useDashboardStore } from '@/core/hooks/useDashboardStore';
import { DashboardService } from '@/core/services/Dashboard.service';
import { DASHBOARD_ACTIVITY_SEVERITY_COLORS } from '@/core/constants/dashboard.constants';
import { getDashboardLinkProps, hasDashboardRoute } from '@/core/helpers/resolve-dashboard-route';
import type {
  DashboardActivityItem,
  DashboardRecentActivitiesData,
} from '@/core/interfaces/Dashboard';

const previewLimit = 5;


export default /*#__PURE__*/_defineComponent({
  __name: 'RecentActivitiesWidget',
  props: {
    compact: { type: Boolean }
  },
  setup(__props: any) {



const { scope } = useDashboardStore();
const showAll = ref(false);
const activityLimit = computed(() => (showAll.value ? 20 : previewLimit));

watch(scope, () => {
  showAll.value = false;
});

const {
  data,
  isFetching,
  isError,
  isEmpty,
  isStale,
  generatedAt,
  refetch,
} = useDashboardQuery<DashboardRecentActivitiesData>(
  'recent-activities',
  scope,
  (s) =>
    DashboardService.getRecentActivities(s, {
      limit: activityLimit.value,
    }),
  {
    filters: computed(() => ({
      limit: activityLimit.value,
      show_all: showAll.value,
    })),
  }
);

const visibleItems = computed(() => data.value?.items ?? []);

const hasMore = computed(
  () =>
    !showAll.value &&
    (Boolean(data.value?.nextCursor) ||
      (data.value?.items?.length ?? 0) >= previewLimit)
);

function severityColor(severity?: string): string {
  if (!severity) {
    return DASHBOARD_ACTIVITY_SEVERITY_COLORS.default;
  }
  return (
    DASHBOARD_ACTIVITY_SEVERITY_COLORS[severity] ??
    DASHBOARD_ACTIVITY_SEVERITY_COLORS.default
  );
}

function routeProps(item: DashboardActivityItem): Record<string, unknown> {
  return getDashboardLinkProps(item.route);
}

function formatTime(value: string): string {
  try {
    return new Date(value).toLocaleTimeString('vi-VN', {
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return value;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardWidget, {
    title: "Hoạt động gần đây",
    compact: _ctx.compact,
    loading: _unref(isFetching),
    error: _unref(isError),
    empty: _unref(isEmpty),
    "is-stale": _unref(isStale),
    "generated-at": _unref(generatedAt),
    "has-cached-content": Boolean(_unref(data)),
    "empty-text": "Chưa có hoạt động gần đây.",
    onRetry: _unref(refetch)
  }, {
    default: _withCtx(() => [
      (visibleItems.value.length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleItems.value, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.id,
                class: "recent-activities-widget__item"
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(hasDashboardRoute)(item.route) ? 'router-link' : 'div'), _mergeProps(routeProps(item), { class: "recent-activities-widget__link" }), {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(item.timeLabel || formatTime(item.occurredAt)), 1),
                    _createElementVNode("span", {
                      class: "recent-activities-widget__dot",
                      style: _normalizeStyle({ backgroundColor: severityColor(item.severity) })
                    }, null, 4),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(item.message), 1)
                  ]),
                  _: 2
                }, 1040))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (hasMore.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: "recent-activities-widget__more",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showAll.value = true))
            }, " Xem tất cả > ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["compact", "loading", "error", "empty", "is-stale", "generated-at", "has-cached-content", "onRetry"]))
}
}

})